import React, {useEffect, useRef, useState} from 'react';
import {Parcel} from '../../functions/GlobalData';
import {PersonOverview} from '../../globalData/person/PersonOverview';
import {
    useCheckImportPersonsQuery,
    useDeleteImportDataMutation,
    useTransferImportDataQuery
} from '../../../redux/rtk/injectedPersonApi';
import {useTranslation} from 'react-i18next';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {getUserFromLocalStorage} from '../../functions/Global';
import {Button} from 'primereact/button';
import {CustomConfirmDialog} from '../../global/CustomConfirmDialog';
import {setGeoData} from '../../../functions/functionsOpenlayer';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';

type Props = {
    project: any,
    importId: number,
    importHappened: boolean,
    // geoData:any

}

export const ImportPreview = (props: Props) => {
    const [preview, setPreview] = useState(<div></div>);
    const importState = useAppSelector((state: any) => state.importData.importState);
    const [skipImport, setSkipImport] = useState<boolean>(true);
    const [showBttns, setShowBttns] = useState<boolean>(false);
    const {t} = useTranslation(['common']);
    const projectId = props.project ? props.project.id : null;
    const user: any = getUserFromLocalStorage();
    const geoDataProject = setGeoData(props);

    const [deleteImportData, resultDeleteImportData] = useDeleteImportDataMutation();
    const importData = useTransferImportDataQuery({projectId: projectId}, {skip: skipImport});


    const person = useCheckImportPersonsQuery({projectId: projectId});
    const getOwnImportedData = () => {
        return user && person.data.benutzer_id === user.id;
    };

    useEffect(() => {
        console.log(importData);
        if (importData.data) {
            if (importData.data.Status === 'OK') {
                showMessageOnSuccess(t('globalData:global.getCSVDialog.headerImportedData'), t('globalData:toasts.importComplete'));
                person.refetch();
            } else {
                showMessageOnError(t('globalData:toasts.importError'), JSON.stringify(importData.data));
            }
        }
    }, [importData.data]);

    const loadPreviewData = () => {
        switch (props.importId) {
            case 1:
                const alkisView = (
                    <PersonOverview projectId={projectId}
                                    showParcels={true}
                                    showPersons={false}
                                    showLandRegisters={true}
                                    showSuggestions={true}
                                    showShareInfos={false}
                                    editable={true}
                                    expandable={true}
                                    hideGlobalFilter={true}
                        // commonData={true}
                                    commonData={false}
                                    showColumnFilters={false}
                                    geoData={geoDataProject}
                                    changed={Math.random()}
                                    hideButtons={true}

                    />);
                setShowBttns(true);
                setPreview(alkisView);
                break;
            default:
                setShowBttns(false);
                break;
        }
    };

    const onClickDeleteImport = (e: any) => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.deleteImport'),
            header: t('confirmDialog:deleteDialogHeader'),
            translation: t,
            onConfirm: () => {
                deleteImportData();
            }
        });
    };

    const submitImport = () => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.finishImport.message'),
            header: t('globalData:dialogs.finishImport.header'),
            translation: t,
            onConfirm: () => {
                setSkipImport(false);
            }
        });
    };

    const getPreview = () => {
        console.log(importState);
        if (props.importId && getOwnImportedData()) {
            setPreview(<div></div>);
            loadPreviewData();
        } /* else {
            setPreview(<div>
                <p>{t('globalData:global.importedDataDialog.notYourData')}</p>
                <p>{person.data.benutzer_name}</p>
                <p>{new Date(person.data.zeitstempel).toLocaleString()}</p></div>);
        }*/
    };
    useEffect(() => {
        getPreview();
    }, [importState, props.importId]);


    return (<>{showBttns && <div><Button
        type="button"
        label={t('common:save')}
        icon="pi pi-file"
        className="p-button-text"
        onClick={submitImport}
    /><Button
        type="button"
        label={t('globalData:buttons.deleteImport')}
        icon="pi pi-trash"
        className="p-button-text"
        onClick={onClickDeleteImport}
    /></div>}{preview}</>);
};
